import Index from './Index.vue';

export default {
  path: 'estados',
  name: 'estado',
  component: Index,
};
